import { startCase } from 'lodash';

import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { DocumentPdfAbnormalFontDetection, PdfFontAbnormality } from 'dashboard/models/check';

const PDF_FONT_ABNORMALITY_TO_ADDITIONAL_INFORMATION: Record<PdfFontAbnormality, string> = {
  embedded_standard_font:
    'The PDF includes an embedded font that is not part of the standard set of fonts provided by the PDF. Such fonts are often added by editors, indicating possible edits to the document.',
  font_inside_revision:
    'The PDF contains font metadata within one of its revision histories. This metadata allows undo/redo functionality in editors and suggests that the file has been edited.',
  font_key_name:
    'The PDF has unconventional font names in its metadata, which is a common sign of editor usage.',
  xref_position:
    'The PDF includes fonts that are not colocated with other fonts in the document, which deviates from the standard behavior of PDF producers. This suggests that the font may have been inserted by an editor.',
};

export const computeDocumentPdfAbnormalFontDetectionMetadata = (
  check: DocumentPdfAbnormalFontDetection,
): CheckMetadata => {
  if (check.reasons && check.reasons.length > 0 && check.metadata) {
    const abnormality = check.metadata.abnormality;
    return {
      metadata: createSimpleCheckMetadataArray([
        {
          label: 'Filename',
          value: check.metadata['filename'] ? check.metadata['filename'].toUpperCase() : '-',
        },
        {
          label: 'Abnormality',
          value: startCase(abnormality) || '-',
        },
        {
          label: 'Additional Information',
          value: PDF_FONT_ABNORMALITY_TO_ADDITIONAL_INFORMATION[abnormality] || '-',
        },
      ]),
      hideIfVerificationPassed: true,
    };
  }

  return {
    metadata: [],
    hideIfVerificationPassed: true,
  };
};
